import {createAsyncThunk} from '@reduxjs/toolkit';
import {filtersApi} from 'api';
import {IBindBaseEnumEntity} from 'models';
import {toastNotificationManager} from 'toast-notifications';
import {prefix} from './config';

export const fetchAudienceThunk: any = createAsyncThunk<IBindBaseEnumEntity[]>(
  `${prefix} fetchAudience`,
  async (_, {rejectWithValue, dispatch}) => {
    try {
      const {parsedBody} = await filtersApi.getInstrumentAudiences();
      return parsedBody;
    } catch (error) {
      dispatch(
        toastNotificationManager.createErrorToastAction(
          error.parsedBody || error.statusText || 'Failed to fetch audiences. Unknown error occurred.'
        )
      );
      return rejectWithValue(error);
    }
  }
);
